import React, { useState, useEffect } from "react";
import Header from "../../components/Headers/Header";
import { useSelector, useDispatch } from "react-redux";
import {
  Container,
  Card,
  CardBody,
  CardSubtitle,
  Button,
  Row,
  Col,
  Table,
  Input,
  Badge,
  Spinner,
} from "reactstrap";
import moment from "moment";
import ViewChatModal from "components/Modal/ViewChatModal";
import { getChatRefundRequests } from "store/actions/generalActions";
import { getMessageById } from "store/actions/generalActions";
import { allMessageRead } from "store/actions/generalActions";
import { getAllChatsById } from "store/actions/generalActions";
import { refundPayment } from "store/actions/generalActions";

function ChatRefund() {
  const [searchVal, setSearchVal] = useState("");
  let { refundRequests, loading } = useSelector((state) => state.general);
  const [viewChatModal, setViewChatModal] = useState(false);
  const [fanId, setFanId] = useState(false);
  let dispatch = useDispatch();
  const handleViewChatModal = async (chat_id, fan_id) => {
    if (chat_id) {
      dispatch(getMessageById(chat_id));
      dispatch(allMessageRead(chat_id));
      dispatch(getAllChatsById(fan_id));
      setFanId(fan_id);
    }
    setViewChatModal(!viewChatModal);
  };
  useEffect(() => {
    dispatch(getChatRefundRequests());
  }, []);
  return (
    <>
      <Header />
      <Container fluid>
        <Row className="no-gutters justify-content-center">
          <Col lg={4} md={6} align="center">
            <div className={`complaint-card complaint-card-active"}`}>
              <p className="complaint-card-number mt-3">
                {refundRequests?.length > 0 ? refundRequests?.length : 0}
              </p>
              <br />
              <p className="complaint-card-text">Total Refund Requests</p>
            </div>
          </Col>
          <Col lg={4} md={6} align="center" className="mt-3 mt-md-0">
            <div
              className={`complaint-card complaint-card-active"
              }`}
            >
              <p className="complaint-card-number mt-3">
                {refundRequests?.length > 0
                  ? refundRequests.filter((ele) => ele.status != "pending")
                      .length
                  : 0}
              </p>
              <br />
              <p className="complaint-card-text">Refund Approved</p>
            </div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col>
            <Card className="filter-card">
              <CardBody className="custom-card-body">
                <Row className="mt-1">
                  <Col>
                    <Input
                      value={searchVal}
                      onChange={(e) => setSearchVal(e.target.value)}
                      type="text"
                      className="custom-filter-input"
                      placeholder="Search"
                    />
                  </Col>
                  <Col align="end">
                    <Button color="danger" onClick={() => setSearchVal("")}>
                      Clear
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {refundRequests?.length == 0 ? (
          <Card className="filter-card mt-5">
            <CardBody className="bg-danger text-center rounded">
              <h2 className="text-white">
                <i className="fa fa-exclamation-triangle mr-3"></i> No Refund
                Requests Found
              </h2>
            </CardBody>
          </Card>
        ) : (
          <Table className="align-items-center table-flush mt-3" responsive>
            <thead>
              <tr>
                <th scope="col" className="custom-table-heading custom-heading">
                  Fan Name
                </th>
                <th scope="col" className="custom-table-heading custom-heading">
                  Athlete Name
                </th>
                <th scope="col" className="custom-table-heading custom-heading">
                  Request Date
                </th>
                <th scope="col" className="custom-table-heading custom-heading">
                  Refund Reason
                </th>
                <th scope="col" className="custom-table-heading custom-heading">
                  Status
                </th>
                <th scope="col" className="custom-table-heading custom-heading">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="custom-table-body mt-3">
              {refundRequests
                ?.filter((val) => {
                  if (searchVal == "") {
                    return val;
                  } else if (
                    val?.fan?.name
                      .toLowerCase()
                      .includes(searchVal.toLowerCase()) ||
                    val.athlete.first_name
                      .toLowerCase()
                      .includes(searchVal.toLowerCase()) ||
                    val.athlete.last_name
                      .toLowerCase()
                      .includes(searchVal.toLowerCase())
                  ) {
                    return val;
                  }
                })
                .map((ele, idx) => {
                  return (
                    <tr key={idx}>
                      <td className={`custom-table-text`}>{ele.fan?.name}</td>
                      <td className="custom-table-text">
                        {`${ele?.athlete?.first_name} ${ele?.athlete?.last_name}`}
                      </td>
                      <td className="custom-table-text">
                        {moment
                          .unix(ele.created_at.seconds)
                          .format("DD MMM YYYY")}
                      </td>
                      <td className="custom-table-text">
                        {ele?.refund_reason}
                      </td>
                      <td>
                        <Badge color="info" className="text-danger">
                          {ele.status == "pending" ? "Pending" : ele.status}
                        </Badge>
                      </td>
                      <td className={`card-subtitle `}>
                        <Button
                          disabled={ele.status == "COMPLETED" || loading}
                          size="sm"
                          color="primary"
                          onClick={() => {
                            dispatch(refundPayment(ele.id, ele.payment_id));
                          }}
                        >
                          {loading ? <Spinner size="sm" /> : "Approve"}
                        </Button>
                        <i
                          className="fa fa-eye text-info ml-2"
                          onClick={() =>
                            handleViewChatModal(ele.chat_id, ele.fan_id)
                          }
                        ></i>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        )}
      </Container>

      <ViewChatModal
        showChatModal={viewChatModal}
        handleViewChatModal={() => {
          handleViewChatModal("", "", "");
        }}
        fan_id={fanId}
      ></ViewChatModal>
    </>
  );
}

export default ChatRefund;
